import { Box, Icon, Text, WizardStepRenderParams } from '@factorialco/deprecated-design-system'

import { acceptedContentTypes } from 'modules/core/lib/fileFormats'
import i18n from 'modules/core/lib/i18n'

import DropzoneBox from 'modules/documents/components/Documents/DropzoneBox'
import FileList from 'modules/documents/components/FileList'
import type { WizardData } from 'modules/project_management/components/wizards/AddDocumentWizard/types'

interface Props {}

const AttachmentsStep: React.FC<WizardStepRenderParams<WizardData> & Props> = ({
  data,
  onDataChanged,
}) => {
  const ACCEPTED_CONTENT_TYPES = acceptedContentTypes([
    'image/gif',
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/docx',
    'application/doc',
    'application/ms-doc',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/csv',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/zip',
  ])
  const onDrop = (files: File[]) => onDataChanged({ ...data, files: data.files.concat(files) })

  const onRemoveFile = (indexToRemove: number) =>
    onDataChanged({
      ...data,
      files: data.files.filter((_file: File, index: number) => index !== indexToRemove),
    })

  return (
    <Box gap="s24">
      <Text.Normal>{i18n.t('attachments.upload_files.step.title')}</Text.Normal>

      <Box gap="s12" paddingRight="s24">
        <DropzoneBox
          onDrop={onDrop}
          iconName="file-upload"
          multiple
          message={i18n.t('attachments.upload_files.select_or_drag')}
          description={i18n.t('attachments.upload_files.description')}
          accept={ACCEPTED_CONTENT_TYPES}
        />

        {!!data.files && (
          <FileList
            files={data.files}
            renderIcon={() => (
              <Box maxHeight="s32" paddingY="s2">
                <Icon.Medium icon="file-filled" />
              </Box>
            )}
            onDeleteFile={onRemoveFile}
          />
        )}
      </Box>
    </Box>
  )
}

export default AttachmentsStep
